module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticesPairArmsFolded-35d4b6c7dcaec4d89b2c5f631fcbfe04.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticesPairArmsFolded.png
// module id = 2264
// module chunks = 2